// T2T-03-SG1/SG3 — Vendor screen group API wrappers
import { getData, postData, putData, deleteData } from '../FetchApiServices';

export const listScreenGroups   = ()                => getData('t2t/vendor-screen-groups');
export const getScreenGroup     = (code)            => getData(`t2t/vendor-screen-groups/${code}`);
export const addGroupField      = (code, body)      => postData(`t2t/vendor-screen-groups/${code}/fields`, body);
export const updateGroupField   = (code, id, body)  => putData(`t2t/vendor-screen-groups/${code}/fields/${id}`, body);
export const removeGroupField   = (code, id)        => deleteData(`t2t/vendor-screen-groups/${code}/fields/${id}`);
